import React from 'react';
import SocialLinks from 'components/info/SocialLinks';  // Le composant SocialLinks
import AlloMairie from 'components/info/AlloMairie';
import ContactInfo from 'components/info/ContactInfo';
import MetaFooter from 'components/info/MetaFooter';
import TextFooter from 'components/info/TextFooter';
import styles from './Footer.module.css';  // Fichier CSS pour le Footer
import { useSubSite } from 'contexts/SubSiteContext'; // Hook pour vérifier le sous-site
import useDesignSettingsData from 'hooks/useDesignSettingsData';
import useFooterData from 'hooks/useFooterData';
import Spinner from 'components/common/Spinner'

const Footer = () => {

  const { isSubSite, subSiteSlug } = useSubSite();
  const { designSettings, settingsLoading } = useDesignSettingsData();
  const { footerData } = useFooterData(isSubSite, subSiteSlug, {
    forcedEndpoint: '/footer/pharos',
  });

  if (settingsLoading) return <div><Spinner /></div>;

  return (
    <footer>

      <div className={`global-section ${styles.footer}`}>
        <div className={`global-container ${styles.container}`}>
          <div className={styles.socials}>
            <figure>
              {designSettings?.pharosLogo && (
                <img
                  className={styles.logoFooter}
                  src={designSettings.pharosLogo}
                  alt="Logo du Pharos" />
              )}
            </figure>

            <SocialLinks />

          </div>

          <ContactInfo footerData={footerData} />

          <TextFooter />

        </div>

        <MetaFooter />

      </div>

    </footer>
  );
};

export default Footer;
